/* eslint-disable no-unused-vars */
import React, { useMemo, useEffect, useState } from 'react';
import {
  issuanceTypes,
  isAStockOrTokenProject,
  typesProjectType,
} from 'types/projectType';
import { getAmount } from 'util/getAmount';
import { InputFormatNumber, InputOnlyNumbers } from 'components/Form';
import { Div, weight, colors } from 'globalStyle';
import { TextLight } from 'components/Texts';
import { ReactComponent as Plus } from 'assets/icons/plus.svg';
import { ReactComponent as Minus } from 'assets/icons/minus.svg';
import { formatNumber } from 'util/formatNumber';
import {
  calculateAmountStocks,
  calculateStocksFromAmount,
} from 'util/calculateAmountStocks';
import { useMediaQuery } from 'hooks';

export default function InvertInput({
  formProps,
  project,
  max: customMax,
  hideText = false,
}) {
  const isDesktop = useMediaQuery(1023);
  const min = 1;
  const max = useMemo(
    () => customMax
      || project?.availableNodes
      || calculateStocksFromAmount(project, project?.maxAmount)
        - calculateStocksFromAmount(project, project?.currentAmount),
    [project],
  );

  if (isAStockOrTokenProject(project?.projectType)) {
    const [amountStocks, setAmountStocks] = useState(1);

    useEffect(() => {
      formProps.setValue('amountStocks', amountStocks, {
        shouldValidate: true,
      });
    }, [amountStocks]);

    const handlerIncrement = () => {
      if (amountStocks < max) {
        setAmountStocks(Number(amountStocks) + 1);
      }
    };

    const handlerReduction = () => {
      if (amountStocks > min) {
        setAmountStocks(Number(amountStocks) - 1);
      }
    };

    return (
      <Div margin="20px 0 35px" width="100%">
        {!hideText && !isDesktop && (
          <TextLight align="center" mb={15} width="auto" size={13}>
            {project?.issuanceType === issuanceTypes.INDIVIDUAL
              ? `Elige la cantidad de ${typesProjectType[project?.projectType]}`
              : 'Elige la cantidad de paquetes'}
          </TextLight>
        )}

        <Div
          isFlex
          width="100%"
          align={isDesktop ? 'flex-start' : 'center'}
          justify={isDesktop && !hideText ? 'space-between' : 'center'}
          style={{ flexWrap: 'wrap', rowGap: '10px' }}
        >
          {!hideText && (
            <Div>
              <TextLight
                weight={isDesktop && weight.BOLD}
                align="start"
                width="auto"
                size={isDesktop ? 18 : 14}
              >
                Monto a invertir
              </TextLight>
              <TextLight
                weight={isDesktop ? weight.SEMI_BOLD : weight.BOLD}
                align="start"
                width="auto"
                size={18}
              >
                {formatNumber(calculateAmountStocks(project, amountStocks))}
              </TextLight>
              <TextLight align="start" width="auto" size={13}>
                {`${
                  project?.issuanceType === issuanceTypes.INDIVIDUAL
                    ? `${typesProjectType[project?.projectType]} disponibles:`
                    : 'Paquetes disponibles:'
                } ${project?.availableNodes}`}
              </TextLight>
            </Div>
          )}
          <Div>
            {!hideText && isDesktop && (
              <TextLight align="start" mb={5} width="auto" size={13}>
                {project?.issuanceType === issuanceTypes.INDIVIDUAL
                  ? `Elige la cantidad de ${
                    typesProjectType[project?.projectType]
                  }`
                  : 'Elige la cantidad de paquetes'}
              </TextLight>
            )}
            <Div isFlex justify="space-between" align="flex-end">
              <Div
                isFlex
                style={{
                  width: '32px',
                  height: '32px',
                }}
              >
                <Minus
                  color={`${
                    amountStocks > min ? colors.GRAY_1 : colors.input.inactive
                  }`}
                  onClick={() => {
                    handlerReduction();
                  }}
                  style={{
                    cursor: `${amountStocks > min && 'pointer'}`,
                  }}
                />
              </Div>

              <InputOnlyNumbers
                title=""
                width="80px"
                defaultValue={amountStocks}
                style={{
                  margin: '0',
                  fontSize: '20px',
                  padding: '0 5px',
                  textAlign: 'center',
                  fontWeight: weight.MEDIUM,
                }}
                name="amountStocks"
                showCheck={false}
                onChange={(e) => {
                  if (e.target.value) {
                    setAmountStocks(Number(e.target.value));
                  } else {
                    setAmountStocks(e.target.value);
                  }
                }}
                validate={{
                  min: (value) => amountStocks >= min || 'Seleccione un valor mayor que 0',
                  max: (value) => amountStocks <= max
                    || `Agregue un valor igual o menor que ${max}`,
                }}
                {...formProps}
              />

              <Div
                isFlex
                style={{
                  width: '32px',
                  height: '32px',
                }}
              >
                <Plus
                  color={`${
                    amountStocks < max ? colors.GRAY_1 : colors.input.inactive
                  }`}
                  onClick={() => {
                    handlerIncrement();
                  }}
                  style={{
                    cursor: `${amountStocks < max && 'pointer'}`,
                  }}
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    );
  }
  return (
    <>
      <InputFormatNumber
        title="¿Cuánto quieres invertir?"
        name="amount"
        placeholder={`Desde ${formatNumber(project?.minInvestmentAmount, null, project?.currencyIso)}`}
        validate={{
          max: (value) => getAmount(`${value}`) >= project?.minInvestmentAmount
            || `El monto ingresado debe ser mayor o igual a ${formatNumber(
              project?.minInvestmentAmount,
            )}`,
          minValueMultiple: (value) => getAmount(`${value}`) % project?.minInvestmentAmount === 0
            || `El monto ingresado debe ser múltiplo de ${formatNumber(
              project?.minInvestmentAmount,
            )}`,
        }}
        styles={{ textAlign: 'start', width: '100%' }}
        {...formProps}
      />
    </>
  );
}
